function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
/* eslint-disable max-len */
import React from 'react';
import withCssProps from '../../../hocs/withCssProps';
import { StyledIcon } from './StyledIcon';
export var IarrowDown2 = withCssProps(function (props) {
  return /*#__PURE__*/React.createElement(StyledIcon, _extends({
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.1207 9.28859L12.0007 13.1686L15.8807 9.28859C16.2707 8.89859 16.9007 8.89859 17.2907 9.28859C17.6807 9.67859 17.6807 10.3086 17.2907 10.6986L12.7007 15.2886C12.3107 15.6786 11.6807 15.6786 11.2907 15.2886L6.7007 10.6986C6.3107 10.3086 6.3107 9.67859 6.7007 9.28859C7.0907 8.90859 7.7307 8.89859 8.1207 9.28859Z",
    fill: "#495057"
  }));
});